const buildConsumerRequestBody = (projectData, body) => {
  const { projectName, projectPassword } = projectData;

  return {
    projectRequest: {
      projectName,
      projectPassword,
    },
    request: body,
  };
};

export default buildConsumerRequestBody;
